import Vue from 'vue';
import VueRouter from "vue-router";
import PageIndex from "../PageIndex.vue";
import PageRegLink from "../PageRegLink.vue";
import PageRegNotes from "../PageRegNotes.vue";
import PageMyjob from "../PageMyjob.vue";
import PagePrint from "../PagePrint.vue";
import PageNotice from "../PageNotice.vue";
import PageGrade from "../PageGrade.vue";
import PageManagerCount from "../PageManagerCount.vue";
import PageManagerJob from "../PageManagerJob.vue";
import PageManagerExam from "../PageManagerExam.vue";
import PageManagerGrade from "../PageManagerGrade.vue";
import PageManagerSet from "../PageManagerSet.vue";
import PageMockExam from "../PageMockExam.vue";
import PageExamTest from "../PageExamTest.vue";
import Cookies from "js-cookie";
import axios from "axios";
import { MessageBox } from "element-ui";
import { validatePrintTicketAccess } from '../../utils/printTicketAccess';

Vue.use(VueRouter);

const PUBLIC_PATHS = ['/pageIndex', '/pageRegLink', '/pageRegNotes', '/search'];
const APPLICATION_REQUIRED_PATHS = ['/pageMyjob'];

function checkSubmittedApplication() {
    return axios.get('/zhaopinapi/job-applications/currently', {
        headers: { Authorization: Cookies.get('reqToKen') },
    }).then((res) => {
        return !!(res.data && res.data.success && res.data.data);
    }).catch(() => false);
}

function promptRegisterFirst() {
    return MessageBox.alert('请先报名', '提示', {
        confirmButtonText: '我知道了',
        type: 'warning',
    });
}

const routes = [
    {
        path: '/pageIndex',
        component: PageIndex,
        meta: { title: '首页' },
    },
    {
        path: '/pageRegLink',
        component: PageRegLink,
        meta: { title: '报名链接' },
    },
    {
        path: '/search',
        component: PageRegLink,
        meta: { title: '报名链接' },
    },
    {
        path: '/pageRegNotes',
        component: PageRegNotes,
        meta: { title: '报名须知' },
    },
    {
        path: '/pageMyjob',
        component: PageMyjob,
        meta: { title: '我的应聘', requiresApplication: true },
    },
    {
        path: '/pagePrint',
        component: PagePrint,
        meta: { title: '打印准考证', requiresTicket: true },
    },
    {
        path: '/pageNotice',
        component: PageNotice,
        meta: { title: '消息通知' },
    },
    {
        path: '/pageGrade',
        component: PageGrade,
        meta: { title: '成绩查询' },
    },
    {
        path: '/pageManagerCount',
        component: PageManagerCount,
        meta: { title: '数据统计' }
    },
    {
        path: '/pageManagerJob',
        component: PageManagerJob,
        meta: { title: '招聘发布' }
    },
    {
        path: '/pageManagerExam',
        component: PageManagerExam,
        meta: { title: '考试管理' }
    },
    {
        path: '/pageManagerGrade',
        component: PageManagerGrade,
        meta: { title: '成绩维护' }
    },
    {
        path: '/pageManagerSet',
        component: PageManagerSet,
        meta: { title: '系统配置' }
    },
    {
        path: '/pageExamTest',
        component: PageExamTest,
        meta: { title: '笔试练习' }
    },
    {
        path: '/pageMockExam',
        component: PageMockExam,
        meta: { title: '模拟练习', requiresOperationEntrance: true }
    },
    {
        path: '/',
        redirect: '/pageIndex'
    }
];

const router = new VueRouter({
    base: '/zhaopin',
    linkActiveClass:'active',
    routes
});

router.beforeEach((to, from, next) => {
    if (PUBLIC_PATHS.includes(to.path)) {
        next();
        return;
    }
    if (!Cookies.get('reqToKen')) {
        window.alert('您还未登录，请先登录！');
        next({ path: '/pageIndex' });
        return;
    }
    const requiresTicket = to.meta && to.meta.requiresTicket
        || to.path === '/pagePrint';
    if (requiresTicket) {
        validatePrintTicketAccess().then((ok) => {
            if (ok) {
                next();
            } else {
                next(false);
            }
        });
        return;
    }
    const requiresApplication = to.meta && to.meta.requiresApplication
        || APPLICATION_REQUIRED_PATHS.includes(to.path);
    if (requiresApplication) {
        checkSubmittedApplication().then((hasApplication) => {
            if (hasApplication) {
                next();
            } else {
                promptRegisterFirst().finally(() => {
                    next(false);
                });
            }
        });
        return;
    }
    next();
});

export default router;
